import axiosInstans from './axiosInstans';

const initialPath = '/admin/project/';

const projectsCount = 10;
class ProjectsApi {
	async getProjects(page, searchObject) {
		try {
			const projects = await axiosInstans.get(`${initialPath}getpage`, {
				params: { page, count: projectsCount, searchObject },
			});
			return projects.data;
		} catch (error) {
			console.error(error);
		}
	}

	async sendProject(project) {
		try {
			const headers = {
				Authorization: `Bearer ${sessionStorage.getItem('token') || null}`,
			};

			const res = await axiosInstans.post(`${initialPath}create`, project, { headers: headers });
			console.log(res);
		} catch (error) {}
	}

	async dleteProject(id) {
		try {
			await axiosInstans.delete(`${initialPath}delete`, { data: { projectId: id } });
		} catch (error) {
			console.log(error);
		}
	}

	async getProject(id) {
		try {
			return axiosInstans.get(`${initialPath}getproject`, {
				params: {
					id,
				},
			});
		} catch (error) {
			console.log(error);
		}
	}
}

export default new ProjectsApi();
